// Base path della nuova estetica (v2), ora UNICA versione ufficiale servita su root.
// (La v1 è stata dismessa: le rotte v2 vivono sulla radice.)
export const V2_BASE = '';
